import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { GlobalsService } from '../../common/services/globals.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sbe-app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class SbeHeaderComponent implements OnInit,OnChanges {

  constructor(private _global: GlobalsService, public router: Router) { }

   app_partner = {
    isFFM : false,
    partner: ''
  }
  spPartnerNDWY: boolean = false;

  @Input() headerDetails: any;

  urlchec;

  get partner(){
    return GlobalsService.partner;
  }

  get activePartner(){
    return GlobalsService.activePartner;
  }

  ngOnInit() {
    if(GlobalsService.partner === "WY" || GlobalsService.partner === "ND" || GlobalsService.activePartner === "WNY" || GlobalsService.activePartner === "NENY"){
      this.spPartnerNDWY = true;
    }
    else{this.spPartnerNDWY = false;}
  }

  ngOnChanges() {
    this.urlchec =this.router.url;
  }
}
